import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import SecureBaseStore from "./SecureBaseStore";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import SavingStates from "../constants/states/SavingStates";
import {FormFieldWithValidityState} from "./FormFieldWithValidityState";


class AdvertisementCreateViewState {
    constructor(
        savingState,
        title,
        description
    ) {
        this.savingState = savingState;
        this.title = title;
        this.description = description;
    }

    equals(other) {
        return this.savingState === other.savingState &&
            this.title.equals(other.title) &&
            this.description.equals(other.description);

    }
}

class ImmutableAdvertisementCreateViewStateBuilder {

    constructor() {
        this.savingState = SavingStates.NOT_STARTED;
        this.title = FormFieldWithValidityState.initialDefaults("");
        this.description = FormFieldWithValidityState.initialDefaults("");
    }

    static fromState(state) {
        return new ImmutableAdvertisementCreateViewStateBuilder()
            .setSavingState(state.savingState)
            .setTitle(state.title.currentValue, state.title.isValid, state.title.isTouched)
            .setDescription(state.description.currentValue, state.description.isValid, state.description.isTouched);
    }

    setCurrentShowImageIndex(newIndex) {
        this.currentShownImageIndex = newIndex;
        return this;
    }

    setSavingState(newState) {
        this.savingState = newState;
        return this;
    }

    setTitle(title, isValid, isTouched) {
        this.title = new FormFieldWithValidityState(title, isValid, isTouched);
        return this;
    }

    setDescription(description, isValid, isTouched) {
        this.description = new FormFieldWithValidityState(description, isValid, isTouched);
        return this;
    }

    build() {
        return Object.freeze(
            new AdvertisementCreateViewState(
                this.savingState,
                this.title,
                this.description));
    }
}


class AdvertisementCreateViewStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.ADVERTISEMENT_CREATE_VIEW_STORE_UPDATED, ImmutableAdvertisementCreateViewStateBuilder);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_CREATE_TITLE_CHANGED, this.handleTitleChanged);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_CREATE_DESCRIPTION_CHANGED, this.handleDescriptionChanged);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_CREATE_SAVE_SUBMITTED, this.handleSaveStarted);
        this.subscribeToEvent(ActionResultEvents.ADVERTISEMENT_CREATED, this.resetStore);
    }

    handleSaveStarted = (topic, data) => {
        return ImmutableAdvertisementCreateViewStateBuilder.fromState(this.state)
            .setSavingState(SavingStates.SAVING)
            .build();
    };

    handleTitleChanged = (topic, data) => {
        return ImmutableAdvertisementCreateViewStateBuilder.fromState(this.state)
            .setTitle(data.title, data.isValid, true, true)
            .build();
    };

    handleDescriptionChanged = (topic, data) => {
        return ImmutableAdvertisementCreateViewStateBuilder.fromState(this.state)
            .setDescription(data.description, data.isValid, true, true)
            .build();
    };

}

export default new AdvertisementCreateViewStore();